"use client";

import Image from "next/image";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { useMediaQuery } from "@react-hook/media-query";
import { swiperClass } from "@/styles/cva/home.cva";

interface OfferingItem {
  icon: any;
  title: string;
  description: string;
}

export function OfferingSection({ offerings }: { offerings: OfferingItem[] }) {
  const IS_MOBILE_VIEW = useMediaQuery("(max-width: 1000px)");

  return (
    IS_MOBILE_VIEW ? <div className="inline">
        <Swiper
          modules={[Autoplay, Pagination]}
          autoplay={{
            delay: 5000, // Auto slide every 5 seconds
            disableOnInteraction: false, // Keeps autoplay working even after user interaction
          }}
          pagination={{
            clickable: true,
          }}
          loop={true}
          className={swiperClass()}
        >
          {offerings.map((item, index) => (
            <SwiperSlide key={index}>
              <div className="flex flex-col gap-y-6 lg:gap-y-9 p-4 lg:p-8 rounded-xl border border-neutral-dark-200 bg-neutral-dark-50 w-full">
                <Image
                  src={item.icon}
                  className="w-10 lg:w-fit"
                  alt="icon"
                  priority
                />
                <div className="flex flex-col gap-y-3">
                  <h3 className="font-poppins font-semibold text-neutral-light-200">
                    {item.title}
                  </h3>
                  <p className="text-sm lg:text-lg font-medium text-neutral-light-800">
                    {item.description}
                  </p>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div> :
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {offerings.map((item, index) => (
          <div
            key={index}
            className="flex flex-col gap-y-9 p-8 rounded-lg border border-neutral-dark-200 bg-neutral-dark-50 w-full"
          >
            <Image src={item.icon} width={72} height={72} alt="icon" priority />
            <div className="flex flex-col gap-y-3">
              <h3 className="font-poppins font-semibold text-neutral-light-200">
                {item.title}
              </h3>
              <p className="text-sm lg:text-lg font-medium text-neutral-light-800">
                {item.description}
              </p>
            </div>
          </div>
        ))}
      </div> 
    
  );
}
